import { DashboardSkeletonForSalesHead } from "../../Components/SkeletonLoading";
import KPIs from "../../Components/Complaint/Dashboard/KPIs";
import ComplaintAnalytics from "../../Components/Complaint/Dashboard/ComplaintAnalytics";
import { useComplaintsOverview } from "../../utilities/useComplaintsOverview";

const ComplaintsOverview = ({ token, filters }) => {
  const {
    data: response,
    isLoading,
    isError,
    refetch,
  } = useComplaintsOverview({
    token,
    propertyId: filters?.propertyId ?? 0,
    locationId: filters?.locationId ?? 0,
  });

  if (isLoading) {
    return <DashboardSkeletonForSalesHead />;
  }

  if (isError) {
    return (
      <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-4">
        Unable to load complaints overview.
        <button
          type="button"
          onClick={() => refetch()}
          className="ml-2 font-semibold underline"
        >
          Retry
        </button>
      </div>
    );
  }

  if (!response) return null;

  // Keep the response paths consistent with your existing API.
  const data = response.data ?? {};

  return (
    <>
      <KPIs
        data={data.summary}
        setIsShowAnalytics={() => {}}
      />

      <ComplaintAnalytics
        summary={data.summary}
        categoryData={data.complaintsCategoryData ?? []}
        propertyData={data.complainDataByProp ?? []}
        tenantData={data.complainDataByTenant ?? []}
        ageData={data.complainDataByAge ?? []}
        teamData={data.complainTeamData ?? []}
      />
    </>
  );
};

export default ComplaintsOverview;